<template>
    <VDialog v-model="dialogLoading" :max-width="700">
      <VCard class="pa-sm-10 pa-5">
        <VCardTitle class="text-center">Cargando información</VCardTitle>
        <VProgressLinear indeterminate color="primary"></VProgressLinear>
      </VCard>
    </VDialog>
    <div class="content content-page bookmark">
        <div class="container">
            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-8">
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <div class="page-title portfolio-title">
                            <h3 class="mb-0" style="margin:auto">Postulaciones</h3>
                        </div>

                        <!-- Table -->
                        <div class="table-top-section">
                            <!-- <div class="table-header">
                                <h5 class="mb-0">Lista:</h5>
                            </div> -->
                            <div class="table-options">
                                <div class="data-search-input">
                                    <input type="text" class="form-control" placeholder="Buscar aqui" name="search"
                                        id="search">
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>N°</th>
                                        <th>Fecha Postulación</th>
                                        <th>Cargo</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(a, index) in applications" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ a['date_pos'] }}</td>
                                        <td>{{ a['work_pos'] }}</td>
                                        <td><span class="bade success-bg-light">En Proceso</span></td>
                                    </tr>
                                    <tr v-if = !applications>
                                        <td colspan="4" style="text-align:center">No se encontraron resultados</td>
                                    </tr>
                                    <!-- <tr>
                                        <td>29 Sep 2023, 11:26 PM</td>
                                        <td>Asistente de Almacen</td>
                                        <td class="text-success">35</td>
                                        <td><span class="bade success-bg-light">En Proceso</span></td>
                                    </tr>
                                    <tr>
                                        <td>17 Sep 2023, 09:14 AM</td>
                                        <td>Asistente de Tareo</td>
                                        <td class="text-danger">23</td>
                                        <td><span class="bade danger-bg-light">Cerrado</span></td>
                                    </tr>
                                    <tr>
                                        <td>13 Sep 2023, 11:15 AM</td>
                                        <td>Asistente de Recursos Humanos</td>
                                        <td class="text-success">58</td>
                                        <td><span class="bade success-bg-light">En Proceso</span></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                        <!-- /Table -->

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>

<script>
    import axiosIns from '@/plugins/axios.js';
    import { ref } from "vue";

    export default {
        data() {
            return {
                id_applicant: JSON.parse(localStorage.getItem('userData'))?.id_usuario,
                applications:[],
                dataTableApplicants:[],
                dataTableFiltApplicants:[],
                dialogLoading: false,
            }
        },

        mounted(){
            this.getApplicantionsMade();
        },

        methods: {
            getApplicantionsMade(){
                const yo = this
                const data = JSON.stringify({
                    id_applicant : yo.id_applicant
                })

                yo.dataTableApplicants=[]
                yo.dataTableFiltApplicants=[]
                yo.dialogLoading = true;
                const config = {
                    method: 'post',
                    url: '/talentoagv/getApplicantionsMade/',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data,
                }
        
                axiosIns(config)
                    .then(function (response) {
                        console.log(response.data['result'])
                        if (response.data['is_error'] === false){
                            let resultado = response.data['result']
                            // for(let r of resultado){
                            //     let fullName = r['name'] + ' ' + r['first_surname'] + ' ' + r['second_surname'];
                            //     r['fullname'] = fullName; 
                            // }
                            yo.applications = resultado
                            yo.dataTableJobOffers = resultado
                            yo.dataTableFiltJobOffers = resultado

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        yo.$toastr.error(response.data['message'], 'Error')
                    })
                    .finally(function (){
                      yo.dialogLoading = false;
                    })
            },
        },
    }
</script>